import { lazy, Suspense } from 'react';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const PublicWebUploadPage = lazy(() => import('src/pages/apps/web-uploads/public-view'));

// ----------------------------------------------------------------------

export const publicRoutes = [
  {
    path: 'public/web-uploads/:id',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicWebUploadPage />
      </Suspense>
    ),
  },
];
